import { render, staticRenderFns } from "./MeineKarten.vue?vue&type=template&id=709c2e20&scoped=true&"
import script from "./MeineKarten.vue?vue&type=script&lang=js&"
export * from "./MeineKarten.vue?vue&type=script&lang=js&"
import style0 from "./MeineKarten.vue?vue&type=style&index=0&id=709c2e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c2e20",
  null
  
)

export default component.exports